import { apiRequest } from "../index";

export const updateSettings = async (data) => {
  return apiRequest(`/api/admin/hotel/visibility`, "PUT", data );
};